<div class="dashboard-container">
  <!-- Pinned shortcuts -->
  <div *ngIf="pinnedItems && pinnedItems.length > 0" class="pinned-row">
    <h3>
      <mat-icon>push_pin</mat-icon>
      Pinned Shortcuts
    </h3>
    <div class="pinned-list">
      <div class="compact-shortcut" *ngFor="let cat of pinnedItems" (click)="openPinnedReport(cat)">
        <svg-icon [src]="getFpItemIcon(cat?.fpicon?.iconPath)"
                  [svgStyle]="{ 'width.px': 20, 'height.px': 20, 'fill': '#E0AA3E' }"></svg-icon>
        <span class="shortcut-name">{{ cat?.categoryName }}</span>
        <div class="compact-unpin" (click)="togglePin(cat, $event)" matTooltip="Unpin from shortcuts">
          <mat-icon>close</mat-icon>
        </div>
      </div>
    </div>
  </div>


  <!-- Show default dashboard if no Power BI reports are available -->
  <div class="wrapper">
    <ng-container *ngFor="let item of mainItems">
      <div #mainItem class="main-item" [style.color]="item.hoverColorHex">
        <div class="item" (click)="showFpItems(mainItem)">
          <div class="item-title">
            <h1>{{item.name}}</h1>
          </div>
          <div class="item-image">
            <img src="{{item.imageUrl}}" alt="image">
          </div>
        </div>
        <div class="categories hide"
             cdkDropList
             cdkDropListOrientation="horizontal"
             (cdkDropListDropped)="drop($event, item.id)">
          <div class="category"
               #category
               *ngFor="let fpResourceCategory of (item.fpResourceCategories | async)"
               (click)="openReportModal(fpResourceCategory, category)"
               cdkDrag
               [cdkDragData]="fpResourceCategory">
            <div class="handle" cdkDragHandle (click)="$event.stopPropagation()">
              <mat-icon>open_with</mat-icon>
            </div>
            <div class="pin-icon-btn" [class.active]="isPinned(fpResourceCategory)" (click)="togglePin(fpResourceCategory, $event)" matTooltip="Pin to shortcuts">
              <mat-icon>push_pin</mat-icon>
            </div>
            <svg-icon [src]="getFpItemIcon(fpResourceCategory?.fpicon?.iconPath)"
                      [svgStyle]="{ 'width.px':75,'height.px': 70,'fill': item.hoverColorHex }"></svg-icon>
            <span>
              {{fpResourceCategory?.categoryName!}}
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
